// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__5VDCL","header":"About_header__WDUtj","goBack":"About_goBack__+Gzl1","container":"About_container__ARsdv"};